import React from 'react';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import colors from 'styles/colors';
import Content from 'components/_ui/Content';

const OurTeamContainer = styled.div`
  background-color: ${colors.orange100};
  padding: 6.4rem 0 5.6rem;

  & + * {
    margin-top: 7.2rem;
  }

  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 8rem 0 6.4rem;
    
    & + * {
      margin-top: 14.4rem;
    }
  }
`;

const OurTeamHeading = styled.h3`
  & + * {
    margin-top: 6.4rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    text-align: center;
    max-width: 90%;
    margin: 0 auto;
    
    & + * {
      margin-top: 8rem;
    }
  }
`;

const OurTeamImage = styled.img`
  width: 100%;
  
  & + * {
    margin-top: 4rem;
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 5.6rem;
    }
  }
`;

const OurTeamContent = styled.div`
  h3 {
    margin-right: 10.4rem;
    
    & + * {
      margin-top: 1.6rem;
    }
  }
  
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    
    h3 {
      & + * {
        margin-top: 0;
      }
    }
  }
`;

const OurTeamDescription = styled.div`
  @media (min-width: ${dimensions.tabletLandscapeUp}px) {
    flex: 1 1 66.6667%;
    
    > div {
      max-width: 74.8rem;
    }
  }
`;

const OurTeam = ({ heading, image, secondaryHeading, content }) => {
  return (
    <OurTeamContainer>
      <Inner>
        {heading && <OurTeamHeading>{heading}</OurTeamHeading>}
        {image && <OurTeamImage src={image.url} alt={image.alt}/>}

        <OurTeamContent>
          {secondaryHeading && <h3>{secondaryHeading}</h3>}

          <OurTeamDescription>
            { content && <Content content={content} />}
          </OurTeamDescription>
        </OurTeamContent>
      </Inner>
    </OurTeamContainer>
  );
};

export default OurTeam;
